import { z } from 'zod';

/**
 * Runtime env schema. Apps build their own env object from import.meta.env
 * and validate at startup. Fail fast if anything is missing.
 */
export const publicEnvSchema = z.object({
  MODE: z.enum(['development', 'production', 'test']).default('development'),
  API_BASE_URL: z.string().url().default('http://localhost:8000/api'),
  ASSET_BASE_URL: z.string().url().optional(),
  APP_BASE_URL: z.string().url().default('http://localhost:5173'),
  BASE_PATH: z
    .string()
    .regex(/^\/(?:[^?#]*\/)?$/)
    .default('/'),
  CHECKOUT_MAP_STYLE_URL: z.string().url().optional(),
  DEFAULT_LOCALE: z.enum(['ge', 'en']).default('ge'),
  APP_VERSION: z.string().default('0.0.0'),
  SEO_INDEXABLE: z.enum(['0', '1']).default('0'),
  GTM_ID: z
    .string()
    .regex(/^GTM-[A-Z0-9]+$/)
    .optional(),
  META_PIXEL_ID: z.string().regex(/^\d+$/).optional(),
  FEATURE_FLAGS: z.string().optional(),
});

export type PublicEnv = z.infer<typeof publicEnvSchema>;

export function loadPublicEnv(raw: Record<string, unknown>): PublicEnv {
  const result = publicEnvSchema.safeParse(raw);
  if (!result.success) {
    console.error('Invalid environment configuration:', result.error.flatten().fieldErrors);
    throw new Error('Invalid environment configuration. See console for details.');
  }
  return result.data;
}
